<template>
  <div class="email-privew">
    <div class="form-header">
      <div class="form-header-innner">
        <a-button
          v-if="!priview"
          class="form-back-btn"
          @click="handleBack"
        >
          返回
        </a-button>
        <div class="tab-box clearfix">
          <span
            :class="['fl', {active: tab === 'pc'}]"
            @click="changeTab('pc')"
          ><i class="iconfont iconpc" /> PC端效果</span>
          <span
            :class="['fl', {active: tab === 'mobile'}]"
            @click="changeTab('mobile')"
          ><i class="iconfont iconmobile" />手机端效果</span>
        </div>
      </div>
    </div>
    <div :class="['wrap', 'quill-editor-box', {'isMobile': tab === 'mobile', 'isPc': tab === 'pc'}]">
      <div
        class="email-content opacity_scrollbar"
        v-html="content"
      />
      <!-- 退订的样式，发给后端用 -->
      <!-- <div style="margin: 20px 0; height: 38px; line-height: 38px; text-align: center; border-top: solid 1px #ebebeb;">
        <a style="font-size: 14px; color: #666; text-decoration: underline;">Unsubscribe</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getStorage } from '@/lib/storage'

export default {
  name: 'EmailPrivew',
  data () {
    return {
      tab: 'pc',
      content: ''
    }
  },
  computed: {
    ...mapState('edm/editEmail', ['emailInfo']),
    emailid () {
      return this.$route.query.emailid || ''
    },
    priview () {
      return this.$route.query.priview || ''
    },
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      return 'EDM营销' + projectname + comname
    }
  },

  watch: {
    tab: {
      handler (val) {
        setTimeout(() => {
          this.setImgWidth()
        }, 100)
      },
      immediate: true
    },
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },

  async mounted () {
    if (this.priview) { // 预览，用缓存里的数据
      let content = getStorage('email.content')
      this.content = this.resetAHref(content)

      document.title = this.documentTitle
    } else { // 查看，用获取邮件详情接口
      let chain = await this.fetchEmailInfo({
        id: this.emailid,
        isdetails: 0
      })
      chain.onSuccess(res => {
        let { content } = this.emailInfo
        this.content = this.resetAHref(content)

        this.$nextTick(() => {
          this.setImgWidth()
        })

        document.title = this.documentTitle
      })
    }
  },

  methods: {
    ...mapActions('edm/editEmail', ['fetchEmailInfo']),
    handleBack () {
      if (!this.priview) { // 查看
        this.$router.push({
          name: 'EmailList',
          query: {
            emailid: this.emailid
          }
        })
      }
    },
    changeTab (type) {
      this.tab = type
    },
    setImgWidth () {
      let $imgs = document.documentElement.querySelectorAll('.email-privew .email-content img')

      if (!$imgs || !$imgs.length) return

      for (let i in $imgs) {
        let $img = $imgs[i]
        let src = $img.src
        this.imgLoad(src, (width, height) => {
          const $parent = document.documentElement.querySelector('.email-privew .email-content')
          const maxWidth = $parent.offsetWidth - 20
          let imgWidth = $img.getAttribute('width') ? parseInt($img.getAttribute('width')) : width
          if (imgWidth > maxWidth) {
            $img.style.width = maxWidth + 'px'
          } else {
            $img.style.width = imgWidth + 'px'
          }
          $img.style.height = 'auto'
        })
      }
    },
    imgLoad (url, callback) {
      var img = new Image()

      img.src = url
      if (img.complete) {
        callback(img.width, img.height)
      } else {
        img.onload = function () {
          callback(img.width, img.height)
          img.onload = null
        }
      };
    },
    resetAHref (str) {
      // 写的url正则匹配
      let reg = /href="(.*?)"/ig
      // 正则替换
      str = str.replace(reg, function (a) {
        console.log(a)
        if (a.indexOf('http') === -1) {
          let href = ''
          if (a.indexOf('=') !== -1) {
            href = a.split('=')[1]
            href = href.replace(/"/g, '')
          }

          return `href="//${href}"`
        } else {
          return a
        }
      })
      console.log(str)
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.form-header {
  width: 100%;
  height: 56px;
  background: #fff;
  border-bottom :1px solid rgba(235,235,235,1);
  .form-header-innner {
    height: 100%;
    padding: 12px 0;
    max-width: 1280px;
    margin: 0 auto;
    line-height: 32px;
    position: relative;
    text-align: center;
    .sub-form-btn {
      position: absolute;
      right: 0;
      top: 12px;
    }
    .form-back-btn {
      position: absolute;
      left: 0;
      top: 12px;
    }
    .tab-box {
      display: inline-block;
      margin-top: 4px;
      & > span {
        cursor: pointer;
        padding: 0 16px;
        color: rgba(0,0,0,.65);
        height:40px;
        line-height: 40px;
        margin-right: 2px;
        background:rgba(0,0,0,0.02);
        border-radius:2px 2px 0px 0px;
        border:1px solid rgba(235,235,235,1);
      }
      .active {
        color: #1890FF;
        background: #fff;
      }
    }
  }
}
.wrap {
  overflow: hidden;
  &.isPc {
    width: 1280px !important;
    height: calc(100vh - 90px);
    overflow: auto;
    margin: 16px auto 0;
    padding: 10px;
    background-color: #fff;
  }
  &.isMobile {
    overflow: hidden;
    width: 370px;
    height: 705px;
    margin: 32px auto 0;
    padding: 115px 18px 35px;
    background: url('~@/assets/images/iPhone Front@3x.png') no-repeat;
    background-size: 100% 100%;
    .email-content {
      width: 100%;
      height: 100%;
      overflow: auto;
      padding: 10px;
      &::v-deep > table {
        width: 100% !important;
      }
    }
  }
}
</style>

<style>
/* 这里的样式，发送邮件的时候，后端把style插入到编辑邮件的那段代码 */
.quill-editor-box {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  word-wrap: break-word;
}
.quill-editor-box p,
.quill-editor-box ol,
.quill-editor-box ul,
.quill-editor-box pre,
.quill-editor-box blockquote,
.quill-editor-box h1,
.quill-editor-box h2,
.quill-editor-box h3,
.quill-editor-box h4,
.quill-editor-box h5,
.quill-editor-box h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.quill-editor-box ol,
.quill-editor-box ul {
  padding-left: 1.5em;
}
.quill-editor-box ol li,
.quill-editor-box ul li {
  list-style-type: none;
}
.quill-editor-box ul li::before {
  content: '';
  width: 10px;
  height: 10px;
  background: black;
  border-radius: 5px;
  display: inline-block;
  transform: scale(0.3);
}
.quill-editor-box ul[data-checked=true],
.quill-editor-box ul[data-checked=false] {
  pointer-events: none;
}
.quill-editor-box ul[data-checked=true] li *,
.quill-editor-box ul[data-checked=false] li * {
  pointer-events: all;
}
.quill-editor-box ul[data-checked=true] li::before,
.quill-editor-box ul[data-checked=false] li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.quill-editor-box ul[data-checked=true] li::before {
  content: ".";
}
.quill-editor-box ul[data-checked=false] li::before {
  content: ".";
}
.quill-editor-box li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.quill-editor-box li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.quill-editor-box li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.quill-editor-box ol li:not(.ql-direction-rtl),
.quill-editor-box ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.quill-editor-box ol li.ql-direction-rtl,
.quill-editor-box ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.quill-editor-box ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.quill-editor-box ol li:before {
  content: counter(list-0, decimal) ". ";
}
.quill-editor-box ol li.ql-indent-1 {
  counter-increment: list-1;
}
.quill-editor-box ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
.quill-editor-box ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-2 {
  counter-increment: list-2;
}
.quill-editor-box ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
.quill-editor-box ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-3 {
  counter-increment: list-3;
}
.quill-editor-box ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
.quill-editor-box ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-4 {
  counter-increment: list-4;
}
.quill-editor-box ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
.quill-editor-box ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-5 {
  counter-increment: list-5;
}
.quill-editor-box ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
.quill-editor-box ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-6 {
  counter-increment: list-6;
}
.quill-editor-box ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
.quill-editor-box ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.quill-editor-box ol li.ql-indent-7 {
  counter-increment: list-7;
}
.quill-editor-box ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
.quill-editor-box ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.quill-editor-box ol li.ql-indent-8 {
  counter-increment: list-8;
}
.quill-editor-box ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
.quill-editor-box ol li.ql-indent-8 {
  counter-reset: list-9;
}
.quill-editor-box ol li.ql-indent-9 {
  counter-increment: list-9;
}
.quill-editor-box ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
.quill-editor-box .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.quill-editor-box li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.quill-editor-box .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.quill-editor-box li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.quill-editor-box .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.quill-editor-box li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.quill-editor-box .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.quill-editor-box li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.quill-editor-box .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.quill-editor-box li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.quill-editor-box .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.quill-editor-box li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.quill-editor-box .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.quill-editor-box li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.quill-editor-box .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.quill-editor-box li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.quill-editor-box .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.quill-editor-box li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.quill-editor-box .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.quill-editor-box li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.quill-editor-box .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.quill-editor-box li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.quill-editor-box .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.quill-editor-box li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.quill-editor-box .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.quill-editor-box li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.quill-editor-box .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.quill-editor-box li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.quill-editor-box .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.quill-editor-box li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.quill-editor-box .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.quill-editor-box li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.quill-editor-box .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.quill-editor-box li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.quill-editor-box .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.quill-editor-box li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.quill-editor-box .ql-video {
  display: block;
  max-width: 100%;
}
.quill-editor-box .ql-video.ql-align-center {
  margin: 0 auto;
}
.quill-editor-box .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.quill-editor-box .ql-bg-black {
  background-color: #000;
}
.quill-editor-box .ql-bg-red {
  background-color: #e60000;
}
.quill-editor-box .ql-bg-orange {
  background-color: #f90;
}
.quill-editor-box .ql-bg-yellow {
  background-color: #ff0;
}
.quill-editor-box .ql-bg-green {
  background-color: #008a00;
}
.quill-editor-box .ql-bg-blue {
  background-color: #06c;
}
.quill-editor-box .ql-bg-purple {
  background-color: #93f;
}
.quill-editor-box .ql-color-white {
  color: #fff;
}
.quill-editor-box .ql-color-red {
  color: #e60000;
}
.quill-editor-box .ql-color-orange {
  color: #f90;
}
.quill-editor-box .ql-color-yellow {
  color: #ff0;
}
.quill-editor-box .ql-color-green {
  color: #008a00;
}
.quill-editor-box .ql-color-blue {
  color: #06c;
}
.quill-editor-box .ql-color-purple {
  color: #93f;
}
.quill-editor-box .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.quill-editor-box .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.quill-editor-box .ql-size-small {
  font-size: 0.75em;
}
.quill-editor-box .ql-size-large {
  font-size: 1.5em;
}
.quill-editor-box .ql-size-huge {
  font-size: 2.5em;
}
.quill-editor-box .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.quill-editor-box .ql-align-center {
  text-align: center;
}
.quill-editor-box .ql-align-justify {
  text-align: justify;
}
.quill-editor-box .ql-align-right {
  text-align: right;
}
.quill-editor-box.ql-blank::before {
  color: rgba(0,0,0,0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
.quill-editor-box .strong {
  font-weight: bold;
}
.quill-editor-box .em {
  font-style: italic;
}
.quill-editor-box img {
  max-width: 100%;
}

.ql-font-SimSun {
  font-family: "STSong", "SimSun";
}
.ql-font-SimHei {
  font-family: "STHeiti", "SimHei";
}
.ql-font-MicrosoftYaHei {
  font-family: "Microsoft YaHei", "微软雅黑";
}
.ql-font-KaiTi {
  font-family: "STKaiti", "KaiTi";
}
.ql-font-FangSong {
  font-family: "STFangsong", "FangSong";
}
.ql-font-LiSu {
  font-family: "隶书", "LiSu", "STLiti", "MingLiu", "LiShu";
}
.ql-font-youyuan {
  font-family: "YouYuan", "youyuan";
}
.ql-font-Arial {
  font-family: "Arial";
}
.ql-font-ArialBlack {
  font-family: "Arial Black";
}
.ql-font-TimesNewRoman {
  font-family: "Times New Roman";
}
.ql-font-Verdana {
  font-family: "Verdana";
}
.quill-editor-box blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
</style>
